import * as React from "react";

const Content = (props: {children?: React.ReactNode}) => (
    <div className="ll-main-content">
        {props.children}
    </div>
);

export default Content;